import { render, staticRenderFns } from "./InviteTPA.vue?vue&type=template&id=523c5aa8&"
import script from "./InviteTPA.vue?vue&type=script&lang=js&"
export * from "./InviteTPA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports